import * as R from "ramda";
import * as React from "react";

import { courseInstructionViews } from "../../../../../utils/courseViews";
import { ICourseInstruction, Slide } from "../../../../course-author/types";
import { DraggableContainer, DraggablePlaceholder } from "../DraggableContainer.styles";
import { IInstructionalMaterialGroupProps } from "../types";
import { componentIndex } from "../util";
import InstructionDropTarget from "./InstructionDropTarget";
import InstructionListItem from "./InstructionListItem";

export default function InstructionItemWithDropTarget(
  props: IInstructionalMaterialGroupProps
): (value: ICourseInstruction, index: number, array: ICourseInstruction[]) => JSX.Element {
  const navigate = (comp: Slide) => () => {
    props.navigationOperations.setPath(props.unitPath);
    props.navigationOperations.setDisplayedComponent(comp)();
  };

  return (item, idx) => {
    const dropPosition = componentIndex(props.course, props.unitPath, item);

    if (R.isNil(dropPosition)) {
      return <React.Fragment />;
    }

    return (
      <DraggableContainer draggable={true} key={idx}>
        <InstructionDropTarget
          editOperations={props.editOperations}
          dropPosition={dropPosition}
          path={props.unitPath}
          type={courseInstructionViews.type(item)}
          alternateColor={false}
        />
        <InstructionListItem
          addTitle={props.editOperations.addTitle(props.unitPath, item)}
          deleteItem={props.editOperations.deleteComponent(props.unitPath, item)}
          courseUnit={item}
          editOperations={props.editOperations}
          dropPosition={dropPosition}
          item={item}
          key={item.id}
          locale={props.locale}
          maxTitleWidth={props.maxTitleWidth}
          modifyTitle={props.editOperations.modifyTitle(props.unitPath, item)}
          navigate={navigate(item)}
          unitPath={props.unitPath}
          url={`${props.unitUrl}.children.${item.id}`}
          bgColor={props.bgColor}
        />
        <DraggablePlaceholder height={3} />
      </DraggableContainer>
    );
  };
}
